import { render, staticRenderFns } from "./TopEntityComponentSlider.vue?vue&type=template&id=aa4cf29a&"
import script from "./TopEntityComponentSlider.vue?vue&type=script&lang=js&"
export * from "./TopEntityComponentSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EmptyTopEntityComponentSlider: require('/srv/rir-platform/tourism/src/tourism-front/components/common/EmptyTopEntityComponentSlider/index.vue').default,ImageComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/ImageComponent/index.vue').default,RoundButton: require('/srv/rir-platform/tourism/src/tourism-front/components/common/RoundButton/index.vue').default,SliderBullets: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SliderBullets/index.vue').default})
